import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const NavBar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setOpen(false);
    navigate('/');
  };

  return (
    <header className="sticky top-0 z-50 bg-black/70 md:bg-black/20 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3">
        <div className="flex justify-between items-center">
          {/* Brand */}
          <Link to={user ? '/dashboard' : '/'} className="flex items-center">
            <span className="text-lg font-mystical font-bold text-white">ASTRALYZ</span>
          </Link>

          {/* Desktop menu */}
          <nav className="hidden md:flex items-center space-x-4">
            {user ? (
              <>
                <Link to="/dashboard" className="px-3 py-2 text-white hover:text-gold-400 transition-colors">Hoje</Link>
                <Link to="/consultation-history" className="px-3 py-2 text-white hover:text-gold-400 transition-colors">Histórico</Link>
                <Link to="/profile" className="px-3 py-2 text-white hover:text-gold-400 transition-colors">Meu Perfil</Link>
                <Link
                  to="/checkout"
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-yellow-500 to-yellow-400 text-black rounded-full text-sm font-semibold hover:from-yellow-400 hover:to-yellow-300 transition-all"
                >
                  ✨ {user.tokens_balance ?? 0} tokens
                </Link>
                {isAdmin && (
                  <Link to="/admin" className="px-3 py-2 text-white hover:text-gold-400 transition-colors">Admin</Link>
                )}
                <button onClick={handleLogout} className="px-3 py-2 text-white hover:text-red-400 transition-colors">Sair</button>
              </>
            ) : (
              <>
                <Link to="/login" className="px-3 py-2 text-white hover:text-gold-400 transition-colors">Entrar</Link>
                <Link to="/register" className="px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-full font-semibold hover:from-purple-700 hover:to-indigo-700 transition-colors">Começar Agora</Link>
              </>
            )}
          </nav>

          <button
            aria-label="Abrir menu"
            className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/20"
            onClick={() => setOpen(true)}
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden fixed inset-0 z-50">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-0 h-full w-80 max-w-[80%] bg-[#0F0F23] bg-opacity-90 backdrop-blur-md border-l border-white/10 shadow-xl">
            <div className="flex items-center justify-between p-4 border-b border-white/10">
              <span className="text-white font-semibold">ASTRALYZ</span>
              <button
                aria-label="Fechar menu"
                className="p-2 rounded-md text-white hover:bg-white/10"
                onClick={() => setOpen(false)}
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>

            <nav className="p-4 space-y-1 bg-black/80 text-sm">
              {user ? (
                <>
                  <Link to="/dashboard" onClick={() => setOpen(false)} className="block px-3 py-2 rounded-lg text-white hover:bg-white/10">Hoje</Link>
                  <Link to="/consultation-history" onClick={() => setOpen(false)} className="block px-3 py-2 rounded-lg text-white hover:bg-white/10">Histórico</Link>
                  <Link to="/profile" onClick={() => setOpen(false)} className="block px-3 py-2 rounded-lg text-white hover:bg-white/10">Meu Perfil</Link>
                  <Link
                    to="/checkout"
                    onClick={() => setOpen(false)}
                    className="flex items-center gap-2 px-3 py-2 rounded-lg bg-yellow-500/20 text-yellow-300 hover:bg-yellow-500/30"
                  >
                    ✨ {user.tokens_balance ?? 0} tokens — Comprar
                  </Link>
                  {isAdmin && (
                    <Link to="/admin" onClick={() => setOpen(false)} className="block px-3 py-2 rounded-lg text-white hover:bg-white/10">Admin</Link>
                  )}
                  <button onClick={handleLogout} className="w-full text-left px-3 py-2 rounded-lg text-white hover:bg-white/10">Sair</button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={() => setOpen(false)} className="block px-3 py-2 rounded-lg text-white hover:bg-white/10">Entrar</Link>
                  <Link to="/register" onClick={() => setOpen(false)} className="block px-3 py-2 rounded-lg text-white hover:bg-white/10">Cadastrar</Link>
                </>
              )}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default NavBar;